'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REQUEST_ERROR = exports.REQUEST_ERROR = 'REQUEST_ERROR';
var REQUEST_FAILURE = exports.REQUEST_FAILURE = 'REQUEST_FAILURE';
var REQUEST_START = exports.REQUEST_START = 'REQUEST_START';
var REQUEST_SUCCESS = exports.REQUEST_SUCCESS = 'REQUEST_SUCCESS';
var AUTH_EXPIRED = exports.AUTH_EXPIRED = 'AUTH_EXPIRED';
var AUTH_FAILED = exports.AUTH_FAILED = 'AUTH_FAILED';


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/events.js
// module id = 188
// module chunks = 0